// Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../../assets/logg.jpeg';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const platformLinks = [
    { label: 'Digital Surveyor Profile', href: '/platform' },
    { label: 'Competency Framework', href: '/competency' },
    { label: 'Digital Logbook', href: '/platform' },
    { label: 'Inspection Workflow', href: '/platform' },
    { label: 'Audit Trail & Evidence Vault', href: '/platform' },
  ];

  const industryLinks = [
    { label: 'Oil & Gas', href: '/industries' },
    { label: 'Marine & Offshore', href: '/industries' },
    { label: 'Infrastructure', href: '/industries' },
    { label: 'Manufacturing', href: '/industries' },
    { label: 'Energy & Renewables', href: '/industries' },
  ];

  const companyLinks = [
    { label: 'About Qualion', href: '/about' },
    { label: 'Services', href: '/services' },
    { label: 'Register Interest', href: '/register' },
    { label: 'Partner With Us', href: '/partner' },
  ];

  // ── LEGAL & COMPLIANCE LINKS ──
  const legalLinks = [
    { label: 'Privacy Policy', href: '/legal/privacy' },
    { label: 'Terms of Service', href: '/legal/terms' },
    { label: 'Cookie Policy', href: '/legal/cookies' },
    {
      label: 'Confidentiality & Data Processing',
      href: '/legal/confidentiality',
    },
    { label: 'Security', href: '/legal/security' },
    { label: 'Contact', href: '/contact' },
    { label: 'Legal Entity & Registration', href: '/legal/entity' },
  ];

  return (
    <footer className="footer">

      {/* ================= MAIN FOOTER ================= */}
      <div className="footer-main">
        <div className="container">

          <div className="footer-grid">

            {/* ================= BRAND COLUMN ================= */}
            <div className="footer-brand-column">

              <Link to="/" className="footer-brand">
                <img
                  src={logo}
                  alt="Qualion Logo"
                  className="footer-logo"
                />
              </Link>

              <p className="footer-description">
                A future-ready digital ecosystem for technical
                competence, inspection assurance, and
                professional development across global
                industries.
              </p>

              {/* Contact Information */}
              <div className="footer-contact">

                {/* Email */}
                <a
                  href="mailto:info@qualion.technology"
                  className="footer-contact-link"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      width="20"
                      height="16"
                      x="2"
                      y="4"
                      rx="2"
                    />
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                  </svg>

                  <span>info@qualion.technology</span>
                </a>

                {/* Location */}
                <div className="footer-contact-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0Z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>

                  <span>India — Serving Global Industries</span>
                </div>

                {/* Website */}
                <div className="footer-contact-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <line x1="2" x2="22" y1="12" y2="12" />
                    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                  </svg>

                  <span>qualion.technology</span>
                </div>

              </div>
            </div>


            {/* ================= PLATFORM ================= */}
            <div className="footer-links-column">

              <h4 className="footer-links-title">
                PLATFORM
              </h4>

              <ul className="footer-links-list">
                {platformLinks.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="footer-link"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>

            </div>


            {/* ================= INDUSTRIES ================= */}
            <div className="footer-links-column">

              <h4 className="footer-links-title">
                INDUSTRIES
              </h4>

              <ul className="footer-links-list">
                {industryLinks.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="footer-link"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>

            </div>


            {/* ================= COMPANY ================= */}
            <div className="footer-links-column">

              <h4 className="footer-links-title">
                COMPANY
              </h4>

              <ul className="footer-links-list">
                {companyLinks.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="footer-link"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>

            </div>

          </div>

        </div>
      </div>


      {/* ================= LEGAL LINKS BAR ================= */}
      <div className="footer-legal">
        <div className="container">
          <nav
            className="footer-legal-nav"
            aria-label="Legal and compliance"
          >
            {legalLinks.map((link, index) => (
              <React.Fragment key={link.href}>
                <Link to={link.href} className="footer-legal-link">
                  {link.label}
                </Link>
                {index < legalLinks.length - 1 && (
                  <span
                    className="footer-legal-divider"
                    aria-hidden="true"
                  >
                    ·
                  </span>
                )}
              </React.Fragment>
            ))}
          </nav>
        </div>
      </div>


      {/* ================= BOTTOM BAR ================= */}
      <div className="footer-bottom">

        <div className="container">

          <div className="footer-bottom-content">

            <p className="footer-copyright">
              © {currentYear} Qualion. All rights reserved.
              <span className="footer-separator"> </span>
              <span>Technical Competence</span>
              <span className="footer-separator"> | </span>
              <span>Inspection</span>
              <span className="footer-separator"> | </span>
              <span>Assurance</span>
              <span className="footer-separator"> | </span>
              <span>Services</span>
            </p>

            <p className="footer-tagline">
              Surveyor Management · Competency Framework · Digital Logbook ·
              Inspection Workflow · Assurance Platform
            </p>

          </div>

        </div>

      </div>

    </footer>
  );
};

export default Footer;